import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import ModalImage from "react-modal-image";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import CountUp from "react-countup";
import CurrencyInput from "react-currency-input-field";
import Board from "react-trello";
import CardBoard from "./CardBoard";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetLegalState, getLegal } from "../../../store/legal/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import { resetLegalMasterState, getLegalMaster as onGetLegalMasters, addNewLegalMaster as onAddNewLegalMaster, updateLegalMaster as onUpdateLegalMaster, deleteLegalMaster as onDeleteLegalMaster, getLegalMasterLoading, resetLegalMasterCreateState } from "../../../store/legalMaster/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
//import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrintF4, PrintDocF4 } from "./PrintDocF4";
import PrintDoc from "../../Task/PrintDoc";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";
import SimpleBar from "simplebar-react";

const LegalMaster = (props) => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [legalMasterityDoc, setLegalMasterityDoc] = useState([]);
  const { t } = props;
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalAccPayable, setModalAccPayable] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeMenuTab, setActiveMenuTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [legalList, setLegalList] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, legalMasters, legalMasterAdded, isLegalMasterCreated, isLegalMasterSuccess, loading, error, legals, legalLoading, companies, companyLoading, clients, clientLoading, departments, departmentLoading, branches, branchLoading, legalStatus, legalStatusLoading, budgets, budgetLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    legalMasterAdded: state.LegalMaster.legalMasterAdded,
    legalMasters: state.LegalMaster.legalMasters,
    loading: state.LegalMaster.loading,
    isLegalMasterCreated: state.LegalMaster.isLegalMasterCreated,
    isLegalMasterSuccess: state.LegalMaster.isLegalMasterSuccess,
    error: state.LegalMaster.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    legalStatus: state.LegalStatus.legalStatus,
    legalStatusLoading: state.LegalStatus.loading,
    legals: state.Legal.legals,
    legalLoading: state.Legal.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [detailType, setDetailType] = useState(null);

  const [legalMasterList, setLegalMasterList] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [legalMaster, setLegalMaster] = useState([]);
  const [info, setInfo] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [detailFiles, setDetailFiles] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const [legalStatusList, setLegalStatusList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  //
  const [dataBoard, setDataBoard] = useState({ lanes: [] });
  const [dataPermisionModal, setDataPermissionModal] = useState(null);
  const [id, setId] = useState(null);
  const [modalTrans, setModalTrans] = useState(false);
  const [expense, setExpense] = useState([]);
  const [printTransDoc, setPrintTransDoc] = useState([]);
  const expanseDataRef = useRef([]);
  //

  const searchListTrans = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el.transaction_reff ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.supplier ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.branch ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };


  const toggleMenuTab = (tab) => {
    if (activeMenuTab !== tab) {
      setActiveTab("1");
      setActiveTypeTab("all");
      setActiveMenuTab(tab);
    }
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredLegalMasters = legalMasters;
      if (type !== "all") {
        filteredLegalMasters = legalMasters.filter((legalMaster) => legalMaster.legal_mst_status_legal.id.toString() === type.toString());
      }
      setLegalMasterList(filteredLegalMasters);
      let translist = [];
      for (const data of filteredLegalMasters) {
        for (const trans of data.legal_mst_trans || []) {
          if (trans?.type === "CASH OUT" && (trans.at_rls || []).length > 0) {
            for (const release of trans.at_rls) translist.push(release.at_rls_trx);
          } else {
            translist.push(trans);
          }
        }
      }
      setTransactionList(translist);
    }
  };

  useEffect(() => {
    if (branchSelected && companySelected) {
      handleGetLegalMaster(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected, companySelected]);

  const handleGetLegalMaster = (id, branchId) => {
    dispatch(resetLegalMasterState());
    dispatch(onGetLegalMasters(branchId ? { companyId: id, branchId: branchId } : { companyId: id, ...filerIdRef.current }));

    handleGetDepartment(id);
    handleGetLegalStatus();
    handleGetLegal(id);
    handleGetBudget(id, branchId);
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetLegal = (id) => {
    dispatch(resetLegalState());
    dispatch(getLegal({ companyId: id, type: "inventory" }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetLegalStatus = () => {
    dispatch(resetLegalStatusState());
    dispatch(getLegalStatus({ type: "induk" }));
  };

  useEffect(() => {
    if (!isEmpty(legalMasters)) {
      let filteredLegalMasters = legalMasters;
      if (activeTypeTab !== "all") {
        filteredLegalMasters = legalMasters.filter((legalMaster) => legalMaster.legal_mst_status_legal.id.toString() === activeTypeTab.toString());
      }
      setLegalMasterList(filteredLegalMasters.map((el) => ({ ...el, isChecked: false })));
      const data = legalMasters[legalMasters.length - 1];
      if (info.id) {
        for (const obj of legalMasters) {
          if (obj.id === info.id) {
            setInfo(obj);
            setLocationCord([obj.latitude, obj.longitude]);
          }
        }
      } else {
        setInfo(data);
        setLocationCord([data.latitude, data.longitude]);
      }

      let translist = [];
      for (const data of filteredLegalMasters) {
        for (const trans of (data.legal_mst_trans || []).filter((f) => f.type === "CASH OUT")) {
          if (trans.at_rls) {
            for (const release of trans.at_rls) translist.push(release.at_rls_trx);
          } else {
            translist.push(trans);
          }
        }
      }
      setTransactionList(translist);
    } else {
      setLegalMasterList([]);
      setInfo({});
    }
  }, [legalMasters]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "NAMA",
        isSelected: true,
        data: [],
      },
      {
        id: "luas",
        label: "LUAS",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "HARGA",
        isSelected: true,
        data: [],
      },

      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (legalMasterList.length > 0) {
      legalMasterList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "code");
          if (doc) doc.data.push(data.code);

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(data.name);

          doc = dataDoc.find((d) => d.id === "luas");
          if (doc) doc.data.push(data.luas);

          doc = dataDoc.find((d) => d.id === "owner");
          if (doc) doc.data.push(data.owner);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(data.quantity ?? 0);

          doc = dataDoc.find((d) => d.id === "njop");
          if (doc) doc.data.push(data.njop ?? 0);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(data.price ?? 0);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(data.description);
        }
      });
    }

    setLegalMasterityDoc(dataDoc);
  }, [legalMasterList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (filerIdRef.current && branchList.length > 0) {
      const branchSelectedDefault = branchList[0].options.find((data) => data.value === filerIdRef.current.branchId);
      setSearchBranch(branchSelectedDefault);
    }
  }, [branchList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var data = [];
      var opt = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (legalStatus.length > 0) {
      setLegalStatusList(data);
    }
  }, [legalStatus]);

  const onClickDelete = (legalMaster) => {
    setLegalMaster(legalMaster);
    setDeleteModal(true);
  };

  const handleDeleteLegalMaster = () => {
    if (legalMaster) {
      dispatch(onDeleteLegalMaster(legalMaster));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegalMaster(null);
      setAssetFiles([]);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(
    (type) => {
      if (modalDetail) {
        setModalDetail(false);
        setDetailType(null);
      } else {
        setModalDetail(true);
        setDetailType(type);
      }
    },
    [modalDetail]
  );

  const toggleTrans = useCallback(() => {
    if (modalTrans) {
      setModalTrans(false);
    } else {
      setModalTrans(true);
    }
  }, [modalTrans]);

  const handleUpdate = useCallback(
    (arg, type) => {
      const data = arg;
      handleGetDepartment(data.companyId);
      let legalMasterDetail = [];
      if (data.legalMaster_detail) {
        for (const element of data.legalMaster_detail) {
          legalMasterDetail.push({
            detailId: element.id,
            filename: element.filename,
            originalname: element.originalname,
            description: element.description,
          });
        }
      }
      setDetailFiles(legalMasterDetail);

      let legalMasterProfile = [];
      if (data.legalMaster_profile) {
        for (const element of data.legalMaster_profile) {
          legalMasterProfile.push({
            detailId: element.id,
            filename: element.filename,
            originalname: element.originalname,
            description: element.description,
          });
        }
      }
      setProfileFiles(legalMasterProfile);

      let arrLegalMaster = [];
      if (data.legalMasterity && data.legalMasterity.length > 0) {
        for (const d of data.legalMasterity) {
          arrLegalMaster.push(d);
        }
      } else {
        for (const d of legals) arrLegalMaster.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
      }
      setCheckDocumentList(arrLegalMaster);
      data.legalMasterity = arrLegalMaster;

      let address_legalMaster = {};

      if (Array.isArray(data.legalMaster_address)) {
        for (const address of data.legalMaster_address) {
          if (address.isPrimary) {
            address_legalMaster = address;
            break; // kalau cuma mau 1 primary
          }
        }
      }

      let files = [];
      if (Array.isArray(data.legal_mst_file)) {
        for (const f of data.legal_mst_file) {
          files.push({ filename: f.filename, originalname: f.originalname });
        }
      }
      setAssetFiles(files);

      setLegalMaster({
        id: data.id,
        companyId: data.companyId,
        clientId: data.clientId,
        description: data.description,
        name: data.name,
        code: data.code,
        longitude: data.longitude,
        latitude: data.latitude,
        sph: data.sph ?? "", // JSONB select multi dari nominatif
        nama_pemohon: data.nama_pemohon,
        alamat_pemohon: data.alamat_pemohon,
        ktp_pemohon: data.ktp_pemohon,
        pekerjaan_pemohon: data.pekerjaan_pemohon,
        umur_pemohon: data.umur_pemohon,
        nama_kuasa: data.nama_kuasa,
        alamat_kuasa: data.alamat_kuasa,
        ktp_kuasa: data.ktp_kuasa,
        pekerjaan_kuasa: data.pekerjaan_kuasa,
        umur_kuasa: data.umur_kuasa,
        desa: data.desa,
        kecamatan: data.kecamatan,
        kabupaten: data.kabupaten,
        luas: data.luas,
        branch: data.legal_mst_branch && { label: data.legal_mst_branch.name, value: data.legal_mst_branch.id },
        company: data.legal_mst_company && { label: data.legal_mst_company.name, value: data.legal_mst_company.id },
        client: data.legal_mst_client && { label: data.legal_mst_client.name, value: data.legal_mst_client.id },
        department: data.legal_mst_department && {
          label: data.legal_mst_department.name,
          value: data.legal_mst_department.id,
        },
        legal_mst_status_legal: data.legal_mst_status_legal && {
          label: data.legal_mst_status_legal.name,
          value: data.legal_mst_status_legal.id,
        },
        details: legalMasterDetail,
        profiles: legalMasterProfile,
        legalMaster: data.legalMaster,

        //baru
        agama_pemohon: data.agama_pemohon,
        agama_kuasa: data.agama_kuasa,
        rt: data.rt,
        rw: data.rw,
        nib: data.nib,
        status_tanah: data.status_tanah,
        digunakan_tanah: data.digunakan_tanah,
        batas_batas_tanah: data.batas_batas_tanah,
        utara: data.utara,
        timur: data.timur,
        selatan: data.selatan,
        barat: data.barat,
        tahun_fisik: data.tahun_fisik,
        diperoleh_dari: data.diperoleh_dari,
        tahun: data.tahun,
        nama_saksi1: data.nama_saksi1,
        umur_saksi1: data.umur_saksi1,
        pekerjaan_saksi1: data.pekerjaan_saksi1,
        alamat_saksi1: data.alamat_saksi1,
        nama_saksi2: data.nama_saksi2,
        umur_saksi2: data.umur_saksi2,
        pekerjaan_saksi2: data.pekerjaan_saksi2,
        alamat_saksi2: data.alamat_saksi2,
        jumlah_batasan: data.jumlah_batasan,
        harga_tanah_pasaran: data.harga_tanah_pasaran,
        harga_tanah_sppt: data.harga_tanah_sppt,
        terletak: data.terletak,
        nomor: data.nomor,
        persil: data.persil,
        kelas: data.kelas,
        berdasarkan: data.berdasarkan,
        tanggal: data.tanggal,
        kepala_desa: data.kepala_desa,
        telpon_pemohon: data.telpon_pemohon,
        email_pemohon: data.email_pemohon,
        propinsi: data.propinsi,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, legals]
  );

  const togglePrint = useCallback(
    (type) => {
      toggleDetail(type);
    },
    [toggleDetail, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalMasterList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalMasterList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let price = (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={legalMasterList.find((x) => x.id === data.id).isChecked}
            onChange={() => {
              const updatedData = legalMasterList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setLegalMasterList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleUpdate(data);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  data.statusId = 3;
                  onClickDelete(data);
                }}
              >
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button>
              <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    togglePrint("surat-permohonan");
                  }}
                >
                  SURAT PERMOHONAN PENGUKURAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    togglePrint("surat-pernyataan-fisik-bidang-tanah");
                  }}
                >
                  SURAT PERNYATAAN PENGUASAAN FISIK BIDANG TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    togglePrint("surat-tanda-terima-pengukuran");
                  }}
                >
                  TANDA TERIMA BERKAS PERMOHONAN PENGUKURAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    togglePrint("surat-pernyataan-batas");
                  }}
                >
                  RUMIJA
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
            <button
              className={"btn me-2 btn-sm btn-soft-info"}
              onClick={() => {
                setInfo(data);
                toggleAccPayable();
              }}
            >
              <i className="ri-file-list-3-line fs-12 label-icon align-middle me-1"></i> INVOICE
            </button>
          </ButtonGroup>
        </div>
      );
    },
    id: "#",
  },
  {
    Header: "Nama",
    accessor: "name",
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      let status;
      switch (data?.legal_mst_status?.name) {
        case "DRAFT":
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_mst_status?.name} </span>;
          break;
        case "ACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.legal_mst_status?.name} </span>;
          break;
        case "INACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.legal_mst_status?.name} </span>;
          break;
        default:
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_mst_status?.name} </span>;
          break;
      }
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            setInfo(data);
            setLocationCord([data.latitude, data.longitude]);
          }}
        >
          <div className="mb-1">{data?.name || "NO NAME"}</div>
          <div className="hstack gap-2">
            <span className="badge fw-normal fs-9" style={{ backgroundColor: data?.legal_mst_status_legal?.color, color: "#555  " }}>
              {data?.legal_mst_status_legal.name}
            </span>
            {status}
            {data?.code &&
              <span className="badge fw-normal fs-9 bg-soft-info text-dark">
                {data?.code}
              </span>
            }
          </div>
        </div>
      );
    },
  },
  {
    Header: "Luas",
    accessor: "luas",
    filterable: true,
    Cell: (data) => (
      <span>
        {currencyFormat(data.value ? data.value : 0)} m<sup>2</sup>
      </span>
    ),
  },
  {
    Header: "HGB / Nibel",
    accessor: "code",
    filterable: true,
    Cell: (data) => <span>{data.value}</span>,
  },
  // {
  //   Header: "Tgl Input",
  //   accessor: "createdat",
  //   filterable: true,
  //   Cell: (data) => {
  //     return handleValidDate(data.row.original.createdat);
  //   },
  // },
  // {
  //   id: "Department",
  //   Header: "Departemen",
  //   accessor: "legal_mst_department.name",
  //   filterable: true,
  //   Cell: (data) => <span className="fw-semibold">{data.row.original.pic && `${data.row.original.pic} / `}{data.value}</span>
  // },

  {
    id: "Terhutang",
    Header: "Terhutang",
    accessor: (data) => (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      let payable = (data.row.original.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span
            onClick={() => {
              const dataRow = data.row.original;
              expanseDataRef.current = dataRow.legal_mst_trans || [];
              setInfo(dataRow);
              setExpense(dataRow.legal_mst_trans || []);
              toggleTrans();
            }}
            className="fw-semibold text-info cursor-pointer"
          >
            {currencyFormat(payable)}
          </span>
        </div>
      );
    },
  },
  {
    id: "Terbayar",
    Header: "Terbayar",
    accessor: (data) => (transactionList || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && data.id === element.legalMasterId).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      let price = (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (transactionList || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && data.id === element.legalMasterId).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span
            onClick={() => {
              expanseDataRef.current = data.legal_mst_trans || [];
              setInfo(data);
              setExpense(data.legal_mst_trans || []);
              toggleTrans();
            }}
            className={amount >= price ? "fw-semibold text-success cursor-pointer" : amount > 0 && amount < price ? "fw-semibold text-warning cursor-pointer" : "fw-semibold text-danger cursor-pointer"}
          >
            {currencyFormat(amount)}
          </span>
        </div>
      );
    },
  },
  {
    id: "SisaBayar",
    Header: "Sisa Bayar",
    accessor: (data) => (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) - (transactionList || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && data.id === element.legalMasterId).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (cell) => {
      const data = cell.row.original;
      let price = (data.legal_mst_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (transactionList || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && data.id === element.legalMasterId).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span
            onClick={() => {
              expanseDataRef.current = data.legal_mst_trans || [];
              setInfo(data);
              setExpense(data.legal_mst_trans || []);
              toggleTrans();
            }}
            className={amount >= price ? "fw-semibold text-success cursor-pointer" : amount > 0 && amount <= price ? "fw-semibold text-warning cursor-pointer" : "fw-semibold text-danger cursor-pointer"}
          >
            {currencyFormat(price - amount < 0 ? 0 : price - amount)}
          </span>
        </div>
      );
    },
  },
  {
    id: "Status",
    Header: "Status",
    accessor: "legal_mst_status_legal.name",
    filterable: true,
  },
  {
    id: "Keterangan",
    Header: "Keterangan",
    accessor: "description",
    filterable: true,
  },
  ],
    [legalMasterList, transactionList, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalMasterList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalMasterList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalMasterList, [legalMasterList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department", "Status", "Area", "Terhutang", "Terbayar", "SisaBayar"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetLegalMasters(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLegalList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetLegalMaster(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegalMaster(element.value));
    });
    checkall.checked = false;
  };

  function handleLegalMasterDetailAdd(type) {
    if (type === "profile") setProfileFiles([...profileFiles, { filename: "", originalname: "", description: "" }]);
    else setDetailFiles([...detailFiles, { filename: "", originalname: "", description: "" }]);
  }

  const handleSelectFile = (file) => {
    if (currentImage === "detail") {
      detailFiles[currentImageIndex].filename = file.filename;
      detailFiles[currentImageIndex].originalname = file.originalname;
    } else if (currentImage === "profile") {
      profileFiles[currentImageIndex].filename = file.filename;
      profileFiles[currentImageIndex].originalname = file.originalname;
    } else {
      setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    }
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  useEffect(() => {
    let l = [];

    legalStatus.forEach((el) => {
      l.push({
        id: el.id.toString(),
        sortOrder: el.sort_order,
        title: el.name,
        style: {
          width: 330,
        },
        cards: [],
      });
    });

    l.forEach((el) => {
      legalMasterList.forEach((e) => {
        if (e.statusLegalId !== null) {
          if (el.id.toString() === e.statusLegalId.toString()) {
            el.cards.push({
              id: e.id.toString(),
              description: e.description ?? "",
              image: e.image ?? "",
              data: e ?? null,
            });
          }
        }
      });
    });

    setDataBoard((val) => {
      return {
        ...val,
        lanes: l,
      };
    });
  }, [legalStatus, legalMasterList]);

  const handleSubmitLoading = useCallback(
    (id) => {
      setId(id);
    },
    [setId]
  );


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legalMaster && legalMaster.id) || 0,
      company: (legalMaster && legalMaster.company) || companySelected,
      client: (legalMaster && legalMaster.client) || clientSelected,
      name: (legalMaster && legalMaster.name) ?? "",
      legal_mst_status_legal: (legalMaster && legalMaster.legal_mst_status_legal) ?? "",
      branch: (legalMaster && legalMaster.branch) ?? "",
      department: (legalMaster && legalMaster.department) ?? "",
      sph: (legalMaster && legalMaster.sph) || [],
      longitude: (legalMaster && legalMaster.longitude) ?? "",
      latitude: (legalMaster && legalMaster.latitude) ?? "",
      code: (legalMaster && legalMaster.code) ?? "",
      luas: (legalMaster && legalMaster.luas) ?? "",
      description: (legalMaster && legalMaster.description) ?? "",

      nama_pemohon: (legalMaster && legalMaster.nama_pemohon) ?? "",
      alamat_pemohon: (legalMaster && legalMaster.alamat_pemohon) ?? "",
      ktp_pemohon: (legalMaster && legalMaster.ktp_pemohon) ?? "",
      pekerjaan_pemohon: (legalMaster && legalMaster.pekerjaan_pemohon) ?? "",
      umur_pemohon: (legalMaster && legalMaster.umur_pemohon) ?? "",
      nama_kuasa: (legalMaster && legalMaster.nama_kuasa) ?? "",
      alamat_kuasa: (legalMaster && legalMaster.alamat_kuasa) ?? "",
      ktp_kuasa: (legalMaster && legalMaster.ktp_kuasa) ?? "",
      pekerjaan_kuasa: (legalMaster && legalMaster.pekerjaan_kuasa) ?? "",
      umur_kuasa: (legalMaster && legalMaster.umur_kuasa) ?? "",
      desa: (legalMaster && legalMaster.desa) ?? "",
      kecamatan: (legalMaster && legalMaster.kecamatan) ?? "",
      kabupaten: (legalMaster && legalMaster.kabupaten) ?? "",

      ///baru
      agama_pemohon: (legalMaster && legalMaster.agama_pemohon) ?? "",
      agama_kuasa: (legalMaster && legalMaster.agama_kuasa) ?? "",
      jalan: (legalMaster && legalMaster.jalan) ?? "",
      rt: (legalMaster && legalMaster.rt) ?? "",
      rw: (legalMaster && legalMaster.rw) ?? "",
      nib: (legalMaster && legalMaster.nib) ?? "",
      status_tanah: (legalMaster && legalMaster.status_tanah) ?? "",
      digunakan_tanah: (legalMaster && legalMaster.digunakan_tanah) ?? "",
      batas_batas_tanah: (legalMaster && legalMaster.batas_batas_tanah) ?? "",
      utara: (legalMaster && legalMaster.utara) ?? "",
      timur: (legalMaster && legalMaster.timur) ?? "",
      selatan: (legalMaster && legalMaster.selatan) ?? "",
      barat: (legalMaster && legalMaster.barat) ?? "",
      tahun_fisik: (legalMaster && legalMaster.tahun_fisik) ?? "",
      diperoleh_dari: (legalMaster && legalMaster.diperoleh_dari) ?? "",
      tahun: (legalMaster && legalMaster.tahun) ?? "",
      nama_saksi1: (legalMaster && legalMaster.nama_saksi1) ?? "",
      umur_saksi1: (legalMaster && legalMaster.umur_saksi1) ?? "",
      pekerjaan_saksi1: (legalMaster && legalMaster.pekerjaan_saksi1) ?? "",
      alamat_saksi1: (legalMaster && legalMaster.alamat_saksi1) ?? "",
      nama_saksi2: (legalMaster && legalMaster.nama_saksi2) ?? "",
      umur_saksi2: (legalMaster && legalMaster.umur_saksi2) ?? "",
      pekerjaan_saksi2: (legalMaster && legalMaster.pekerjaan_saksi2) ?? "",
      alamat_saksi2: (legalMaster && legalMaster.alamat_saksi2) ?? "",
      jumlah_batasan: (legalMaster && legalMaster.jumlah_batasan) ?? "",
      harga_tanah_pasaran: (legalMaster && legalMaster.harga_tanah_pasaran) ?? "",
      harga_tanah_sppt: (legalMaster && legalMaster.harga_tanah_sppt) ?? "",
      terletak: (legalMaster && legalMaster.terletak) ?? "",
      nomor: (legalMaster && legalMaster.nomor) ?? "",
      persil: (legalMaster && legalMaster.persil) ?? "",
      kelas: (legalMaster && legalMaster.kelas) ?? "",
      berdasarkan: (legalMaster && legalMaster.berdasarkan) ?? "",
      tanggal: (legalMaster && legalMaster.tanggal) ?? "",
      kepala_desa: (legalMaster && legalMaster.kepala_desa) ?? "",
      //
      telpon_pemohon: (legalMaster && legalMaster.telpon_pemohon) ?? "",
      email_pemohon: (legalMaster && legalMaster.email_pemohon) ?? "",
      propinsi: (legalMaster && legalMaster.propinsi) ?? "",
      jenis_permohonan: (legalMaster && legalMaster.jenis_permohonan) ?? "",
      sps_tgl_terbit: (legalMaster && legalMaster.sps_tgl_terbit) ?? "",
      sps_tgl_maksimal: (legalMaster && legalMaster.sps_tgl_maksimal) ?? "",
      tgl_pengukuran: (legalMaster && legalMaster.tgl_pengukuran) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Silahkan Isi Nama"),
      company: Yup.object().required("Silahkan isi Perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalMasterLoading());
      if (isEdit) {
        let editSubmit = {
          id: values.id,
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          departmentId: values.department.value,
          name: values.name,
          code: values.code,
          description: values.description,
          sph: values.sph,
          statusLegalId: values.legal_mst_status_legal.value,
          longitude: values.longitude,
          latitude: values.latitude,

          nama_pemohon: values.nama_pemohon,
          alamat_pemohon: values.alamat_pemohon,
          ktp_pemohon: values.ktp_pemohon,
          pekerjaan_pemohon: values.pekerjaan_pemohon,
          umur_pemohon: values.umur_pemohon,
          nama_kuasa: values.nama_kuasa,
          alamat_kuasa: values.alamat_kuasa,
          ktp_kuasa: values.ktp_kuasa,
          pekerjaan_kuasa: values.pekerjaan_kuasa,
          umur_kuasa: values.umur_kuasa,

          desa: values.desa,
          kecamatan: values.kecamatan,
          kabupaten: values.kabupaten,
          luas: values.luas,

          ///baru
          agama_pemohon: values.agama_pemohon,
          agama_kuasa: values.agama_kuasa,
          rt: values.rt,
          rw: values.rw,
          nib: values.nib,
          status_tanah: values.status_tanah,
          digunakan_tanah: values.digunakan_tanah,
          batas_batas_tanah: values.batas_batas_tanah,
          utara: values.utara,
          timur: values.timur,
          selatan: values.selatan,
          barat: values.barat,
          tahun_fisik: values.tahun_fisik,
          diperoleh_dari: values.diperoleh_dari,
          tahun: values.tahun,
          nama_saksi1: values.nama_saksi1,
          umur_saksi1: values.umur_saksi1,
          pekerjaan_saksi1: values.pekerjaan_saksi1,
          alamat_saksi1: values.alamat_saksi1,
          nama_saksi2: values.nama_saksi2,
          umur_saksi2: values.umur_saksi2,
          pekerjaan_saksi2: values.pekerjaan_saksi2,
          alamat_saksi2: values.alamat_saksi2,
          jalan: values.jalan,
          jumlah_batasan: values.jumlah_batasan,
          harga_tanah_pasaran: values.harga_tanah_pasaran,
          harga_tanah_sppt: values.harga_tanah_sppt,
          terletak: values.terletak,
          nomor: values.nomor,
          persil: values.persil,
          kelas: values.kelas,
          berdasarkan: values.berdasarkan,
          tanggal: values.tanggal,
          kepala_desa: values.kepala_desa,
          //
          telpon_pemohon: values.telpon_pemohon,
          email_pemohon: values.email_pemohon,
          propinsi: values.propinsi,

          files: assetFiles.length > 0 ? assetFiles : [],
        };
        dispatch(onUpdateLegalMaster(editSubmit));
      } else {
        let addSubmit = {
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          departmentId: values.department.value,
          name: values.name,
          code: values.code,
          description: values.description,
          sph: values.sph,
          statusLegalId: values.legal_mst_status_legal.value,
          longitude: values.longitude,
          latitude: values.latitude,

          nama_pemohon: values.nama_pemohon,
          alamat_pemohon: values.alamat_pemohon,
          ktp_pemohon: values.ktp_pemohon,
          pekerjaan_pemohon: values.pekerjaan_pemohon,
          umur_pemohon: values.umur_pemohon,
          nama_kuasa: values.nama_kuasa,
          alamat_kuasa: values.alamat_kuasa,
          ktp_kuasa: values.ktp_kuasa,
          pekerjaan_kuasa: values.pekerjaan_kuasa,
          umur_kuasa: values.umur_kuasa,

          desa: values.desa,
          kecamatan: values.kecamatan,
          kabupaten: values.kabupaten,
          luas: values.luas,

          ///baru
          agama_pemohon: values.agama_pemohon,
          agama_kuasa: values.agama_kuasa,
          rt: values.rt,
          rw: values.rw,
          nib: values.nib,
          status_tanah: values.status_tanah,
          digunakan_tanah: values.digunakan_tanah,
          batas_batas_tanah: values.batas_batas_tanah,
          utara: values.utara,
          timur: values.timur,
          selatan: values.selatan,
          barat: values.barat,
          tahun_fisik: values.tahun_fisik,
          diperoleh_dari: values.diperoleh_dari,
          tahun: values.tahun,
          nama_saksi1: values.nama_saksi1,
          umur_saksi1: values.umur_saksi1,
          pekerjaan_saksi1: values.pekerjaan_saksi1,
          alamat_saksi1: values.alamat_saksi1,
          nama_saksi2: values.nama_saksi2,
          umur_saksi2: values.umur_saksi2,
          pekerjaan_saksi2: values.pekerjaan_saksi2,
          alamat_saksi2: values.alamat_saksi2,
          jumlah_batasan: values.jumlah_batasan,
          harga_tanah_pasaran: values.harga_tanah_pasaran,
          harga_tanah_sppt: values.harga_tanah_sppt,
          terletak: values.terletak,
          nomor: values.nomor,
          persil: values.persil,
          kelas: values.kelas,
          berdasarkan: values.berdasarkan,
          tanggal: values.tanggal,
          kepala_desa: values.kepala_desa,
          //
          telpon_pemohon: values.telpon_pemohon,
          email_pemohon: values.email_pemohon,
          propinsi: values.propinsi,

          files: assetFiles.length > 0 ? assetFiles : [],
        };
        dispatch(onAddNewLegalMaster(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `SERTIPIKAT INDUK : ${info?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
    }),
    onSubmit: (values) => {
      dispatch(getLegalMasterLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegalMaster(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintTransDoc(dataDoc);
  }, [expense]);

  useEffect(() => {
    if (!isEmpty(legals)) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      legals.forEach((item, key) => {
        const name = item.owner + ",  " + item.code + " " + parseFloat(item.quantity) + "M²";
        const id = item.id;
        var obj = {
          label: name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setLegalList(data);
    }
  }, [legals]);

  const components = {
    Card: (props) => (
      <CardBoard
        idCard={id}
        handleSubmitLoading={handleSubmitLoading}
        isLoadingLegalPermission={loading}
        handleToggleUpdate={(data) => {
          handleUpdate(data);
        }}
        handleToggleMailingPrint={(data, type) => {
          setDataPermissionModal(data);
          togglePrint(type);
        }}
        {...props}
      />
    ),
  };

  const [expandedRowId, setExpandedRowId] = useState(null);
  const handleRowClick = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  document.title = "Sertifikat Induk | Enterprise Resources Planning";

  return (
    <>
      <div className="page-content">
        <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalMasterList} />
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegalMaster} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title="Pertanahan" pageTitle="Sertifikat Induk" loading={loading}>
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegal") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  let arrLegalMaster = [];
                  for (const d of legals) arrLegalMaster.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
                  setCheckDocumentList(arrLegalMaster);
                  validation.setFieldValue("legalMasterity", arrLegalMaster);
                  toggle();
                }}
              >
                <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              <ExportDoc data={legalMasterityDoc} />
            </div>
          </BreadCrumb>
          <div>
            <Card>
              <CardBody className="pt-1 pb-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeMenuTab === "1" }, "fw-semibold")}
                      onClick={() => {
                        toggleMenuTab("1");
                      }}
                      href="#"
                    >
                      <i className="ri-booklet-line me-1 align-bottom fs-14"></i> SEMUA DATA SERTIFIKAT INDUK
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeMenuTab === "2" }, "fw-semibold")}
                      onClick={() => {
                        toggleMenuTab("2");
                      }}
                      href="#"
                    >
                      <i className="ri-information-line me-1 align-bottom fs-14"></i> PROGRESS
                    </NavLink>
                  </NavItem>
                </Nav>
                {/* <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                          onClick={() => {
                            toggleTab("1", "all");
                          }}
                          href="#"
                        >
                          <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> ALL
                        </NavLink>
                      </NavItem>
                      {legalStatus.map((o, i) => (
                        <NavItem key={i}>
                          <NavLink
                            className={classnames({ active: activeTab === i + 2 }, "fw-semibold")}
                            onClick={() => {
                              toggleTab(i + 2, o.id);
                            }}
                            href="#"
                          >
                            <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> {o.name}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav> */}
                <Row className="mb-0">
                  <CardBody className="pb-0">
                    <Row>
                      <Col sm={1}>
                        <div className="me-2 mb-3 col-12">
                          <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                            {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                {pageSize}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col sm={9}>
                        <div className="search-box me-2 mb-3 d-inline-block col-12">
                          <input
                            id="search-bar-0"
                            type="text"
                            className="form-control search"
                            onChange={(e) => {
                              setLegalMasterList(legalMasters.map((el) => ({ ...el, isChecked: false })));
                              setSearchValue(e.target.value);
                              onChange(e.target.value);
                              gotoPage(0);
                            }}
                            placeholder={`${countSearch} Cari...`}
                            value={searchValue ?? ""}
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>

                      <Col sm={2}>
                        <div className="hstack gap-2">
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                            onClick={() => {
                              handleFilter();
                            }}
                          >
                            <i className="ri-search-line align-bottom fs-16"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                            onClick={() => {
                              handleResetFilter();
                            }}
                          >
                            <i className="mdi mdi-restore align-bottom fs-18"></i>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Row>
              </CardBody>
            </Card>
            <div>
              {activeMenuTab === "1" ? (
                <Row>
                  <Col lg={8} style={{ position: "relative" }}>
                    <Card style={{ position: "sticky", top: "94px" }}>
                      <CardBody>
                        <div>
                          <div className="table-responsive table-card mb-1" style={{ minHeight: "380px" }}>
                            <Table hover {...getTableProps()} className="align-middle table-nowrap">
                              <thead className="table-info">
                                {headerGroups.map((headerGroup, index) => (
                                  <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                    {headerGroup.headers.map((column, index) => (
                                      <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                        {column.render("Header")}
                                        {generateSortingIndicator(column)}
                                        {/* <Filter column={column} /> */}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>
                              <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                  prepareRow(row);
                                  let price = (row.original.legal_master_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
                                  let amount = (row.original.legal_master_trans || []).filter((element) => (element.statusId === 2 || element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

                                  return (
                                    <Fragment key={row.id} {...row.getRowProps()} >
                                      <tr className="cursor-pointer" onClick={() => {
                                        handleRowClick(row.id);
                                        setInfo(row.original);
                                      }}>
                                        {row.cells.map((cell, i) => (
                                          <td {...cell.getCellProps()} key={i}>
                                            {cell.render("Cell")}
                                          </td>
                                        ))}
                                      </tr>
                                      {expandedRowId === row.id && (
                                        <tr>
                                          <td></td>
                                          <td colSpan="7" className="cursor-pointer" onClick={() => {
                                            const dataRow = row.original;
                                            expanseDataRef.current = dataRow.legal_master_trans || [];
                                            setExpense(dataRow.legal_master_trans || []);
                                            toggleTrans();
                                          }}>
                                            <div className="d-flex gap-5">
                                              <div>
                                                <strong>Terbayar:</strong>
                                                <p className="fw-semibold text-success">{currencyFormat(row.values.Terbayar)}</p>
                                              </div>
                                              <div>
                                                <strong>Terhutang:</strong>
                                                <p className="fw-semibold text-info">{currencyFormat(row.values.Terhutang)}</p>
                                              </div>
                                              <div>
                                                <strong>Sisa Bayar:</strong>
                                                <p className="fw-semibold text-danger">{currencyFormat(price - amount < 0 ? 0 : price - amount)}</p>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>

                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>

                          <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                            <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button
                                  className="btn btn-light"
                                  onClick={() => {
                                    setPageIdx(pageIndex - 1);
                                    previousPage();
                                  }}
                                  disabled={!canPreviousPage}
                                >
                                  {"<"}
                                </Button>
                              </div>
                            </Col>
                            <Col className="col-md-auto d-none d-md-block">
                              Halaman {pageIndex + 1} dari {pageOptions.length}
                            </Col>
                            <Col className="col-md-auto">
                              <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                            </Col>
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button
                                  className="btn btn-light"
                                  onClick={() => {
                                    setPageIdx(pageIndex + 1);
                                    nextPage();
                                  }}
                                  disabled={!canNextPage}
                                >
                                  {">"}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>


                      </CardBody>
                    </Card>
                  </Col>

                  <Col lg={4}>
                    <Card>
                      <div className="card-body">
                        <table className="table align-middle table-nowrap mb-3">
                          <thead className="table-active">
                            <tr>
                              <th scope="col" className="p-2 pt-3 pb-3">
                                Dokumen:
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(info.legal_mst_file || []).map((file, key) => {
                              let src;
                              return (
                                <tr
                                  key={key + "filehak"}
                                  className="cursor-pointer"
                                  onClick={() => {
                                    const typeFile = file.filename.split(".");
                                    if (typeFile[typeFile.length - 1] === "x-compressed") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "sheet") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "pdf") {
                                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                    } else {
                                      //
                                    }
                                  }}
                                >
                                  <td>
                                    <div className="d-flex">
                                      <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                        <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                      </div>
                                      <div className="flex-grow-1 text-start">
                                        <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                        <p>{file.originalname}</p>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <h6 className="fw-semibold mb-2">Keterangan</h6>
                        <p className="mb-4">{info.description ? info.description : "-"} </p>
                      </div>
                      <CardBody className="text-center">
                        {locationCord !== undefined ||
                          (locationCord !== null && (
                            <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                              <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                              <Marker position={locationCord}>
                                <Popup>{info.legal_mst_branch && info.legal_mst_branch.name ? info.legal_mst_branch.name : "-"}</Popup>
                              </Marker>
                            </MapContainer>
                          ))}

                        <table className="table border table-responsive fs-13 mb-3  text-start">
                          <tbody>
                            <tr>
                              <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                INFORMASI LAINNYA
                              </td>
                            </tr>
                            <tr>
                              <td className="p-2">Perusahaan</td>
                              <td className="p-2">{info.legal_mst_company && info.legal_mst_company.name ? info.legal_mst_company.name : "-"} </td>
                            </tr>
                            <tr>
                              <td className="p-2">SPH</td>
                              <td className="p-2  text-start">{info.sph ? info.sph.map((o, i) => {
                                return <ul key={i}>
                                  <li>{o.label}</li>
                                </ul>
                              }) : "-"} </td>
                            </tr>
                            <tr>
                              <td className="p-2">Area</td>
                              <td className="p-2">
                                {info.latitude}, {info.longitude}
                              </td>
                            </tr>
                            <tr>
                              <td className="p-2">Dibuat Oleh</td>
                              <td className="p-2">{info.legal_mst_createdby && info.legal_mst_createdby.name ? info.legal_mst_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                            </tr>
                            <tr>
                              <td className="p-2">Diedit Oleh</td>
                              <td className="p-2">{info.legal_mst_updatedby && info.legal_mst_updatedby.name ? info.legal_mst_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                <Board
                  data={dataBoard}
                  style={{ padding: "0px" }}
                  className="p-0"
                  components={components}
                  // onBeforeCardDelete={(e) => {
                  //   e();
                  // }}
                  onDataChange={(e) => { }}
                  handleDragEnd={(cardId, sourceLaneId, targetLaneId, position) => {
                    let object = legalMasters.find((obj) => obj.id.toString() === cardId.toString());
                    if (object.statusLegalId.toString() !== targetLaneId.toString()) {
                      const updateContact = { ...object, statusLegalId: Number(targetLaneId) };
                      dispatch(onUpdateLegalMaster(updateContact));
                    }
                  }}
                />
              )}

            </div>
          </div>
        </Container>
        <Modal id="showModal" isOpen={modal} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggle}>
            {!!isEdit ? "Edit Sertifikat Induk" : "Tambah Sertifikat Induk"}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              <CardBody className="border-bottom p-2 pt-0 pb-0 border-bottom-dashed">
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label htmlFor="latitude-field" className="form-label">
                        Grup Usaha
                      </Label>
                      <div className="position-relative">
                        <Select
                          name="client"
                          value={validation.values.client}
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          placeholder="Pilih Grup Usaha"
                          onChange={(e) => {
                            validation.setFieldValue("client", e);
                          }}
                          options={clientList}
                        ></Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            left: "-24px",
                          }}
                        >
                          {clientLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                      {validation.touched.client && validation.errors.client && (
                        <p className="invalid-feedback d-block" type="invalid">
                          {validation.errors.client}
                        </p>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="latitude-field" className="form-label">
                        Perusahaan
                      </Label>
                      <div className="position-relative">
                        <Select
                          name="company"
                          value={validation.values.company}
                          placeholder="Pilih Perusahaan"
                          isDisabled={userType === "admin" || userType === "client" ? false : true}
                          onChange={(e) => {
                            setDepartmentList([]);
                            dispatch(setBranchSelect(null));
                            dispatch(setCompanySelect(e));
                            validation.setFieldValue("company", e);
                            handleGetDepartment(e.value);
                          }}
                          options={companyList}
                        ></Select>
                        <div
                          className="position-absolute"
                          style={{
                            top: "12px",
                            left: "-24px",
                          }}
                        >
                          {companyLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                        </div>
                      </div>
                      {validation.touched.company && validation.errors.company && (
                        <p className="invalid-feedback d-block" type="invalid">
                          {validation.errors.company}
                        </p>
                      )}
                    </div>
                    <div className="mb-3">
                      <Label htmlFor="address-field" className="form-label">
                        {t("Cabang / Proyek")}
                      </Label>
                      <Select
                        name="branch"
                        value={validation.values.branch}
                        placeholder="Pilih Proyek"
                        onChange={(e) => {
                          dispatch(setBranchSelect(e));
                          validation.setFieldValue("branch", e);
                        }}
                        options={branchList}
                      ></Select>
                      {validation.touched.branch && validation.errors.branch && <p className="text-error">{validation.errors.luas}</p>}
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="active-status" className="form-label">
                        SPH
                      </Label>
                      <Select
                        name="sph"
                        value={validation.values.sph}
                        placeholder="SPH"
                        isMulti
                        onChange={(opt, { option }) => {
                          let newOpts = opt;
                          if (option && option.value === "all") {
                            let filteredOptions = clone(legalList);
                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                          }
                          validation.setFieldValue("sph", newOpts);
                        }}
                        options={legalList}
                      ></Select>
                      {validation.touched.sph && validation.errors.sph && <p className="text-error">{validation.errors.luas}</p>}
                    </div>
                    {/* ////nominatif//// */}
                    <div className="mb-3">
                      <Label htmlFor="name-field" className="form-label">
                        {t("Nama Induk")}
                      </Label>
                      <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Induk" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                      {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="code-field" className="form-label">
                        {t("No HGB / Nibel")}
                      </Label>
                      <Input name="code" id="code-field" className="form-control" placeholder="Isi No HGB" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code ?? ""} invalid={validation.touched.code && validation.errors.code ? true : false} />
                      {validation.touched.code && validation.errors.code && <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>}
                    </div>

                    <div className="mb-3">
                      <Label htmlFor="luas-field" className="form-label">
                        Luas
                      </Label>
                      <Input
                        name="luas"
                        id="luas-field"
                        className="form-control"
                        placeholder="Isi Luas"
                        type="text"
                        onChange={(e) => {
                          const val = e.target.value;
                          validation.setFieldValue("luas", val);
                        }}
                        value={validation.values.luas}
                        invalid={validation.touched.luas && validation.errors.luas ? true : false}
                      />
                      {validation.touched.luas && validation.errors.luas ? <FormFeedback type="invalid">{validation.errors.luas}</FormFeedback> : null}
                    </div>
                    <div className="mb-3 col-lg-12">
                      <Label htmlFor="active-status" className="form-label">
                        Status
                      </Label>
                      <Select
                        name="legal_mst_status_legal"
                        value={validation.values.legal_mst_status_legal}
                        placeholder="Pilih Status"
                        onChange={(e) => {
                          validation.setFieldValue("legal_mst_status_legal", e);
                        }}
                        options={legalStatusList}
                      ></Select>
                    </div>
                    <div className="mb-3">
                      <div className="row">
                        <div className="mb-3 col-lg-6 d-none">
                          <Label htmlFor="address-field" className="form-label">
                            {t("Departemen")}
                          </Label>
                          <Select
                            name="department"
                            value={validation.values.department}
                            placeholder="Pilih Departemen"
                            onChange={(e) => {
                              validation.setFieldValue("department", e);
                            }}
                            options={departmentList}
                          ></Select>
                        </div>
                        <div className="mb-3 col-lg-6 ">
                          <Label htmlFor="latitude-field" className="form-label">
                            Latitude
                          </Label>
                          <Input name="latitude" id="latitude-field" className="form-control" placeholder="Isi Latitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.latitude ?? ""} />
                        </div>
                        <div className="mb-3 col-lg-6 ">
                          <Label htmlFor="longitude-field" className="form-label">
                            Longitude
                          </Label>
                          <Input name="longitude" id="longitude-field" className="form-control" placeholder="Isi Longitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longitude ?? ""} />
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label htmlFor="des-field" className="form-label">
                          {t("Keterangan")}
                        </Label>
                        <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                      </div>

                      <div className="mb-3 d-flex justify-content-between">
                        <Label htmlFor="taskFiles" className="form-label me-3">
                          Dokumen
                        </Label>
                        <button
                          type="button"
                          className="btn btn-sm btn-label btn-soft-success"
                          onClick={() => {
                            toggleMedia();
                          }}
                        >
                          <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                        </button>
                      </div>
                      {assetFiles.map((assetFile, i) => {
                        if (assetFile.isDeleted) {
                          return null;
                        } else {
                          return (
                            <div key={i} className="border-bottom mb-3">
                              <div className="d-flex justify-content-between mb-3 align-items-center">
                                <div className="me-2">
                                  <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                </div>
                                <div className="text-truncate">{assetFile.originalname}</div>
                                <div>
                                  <Link
                                    to="#"
                                    className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                    onClick={(e) => {
                                      handleDeleteFile(assetFile);
                                    }}
                                  >
                                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </Col>
                  <Col lg={8} className="ps-3">
                    <h5 className="mb-3 bg-soft-info p-2 pb-3">Pengukuran</h5>
                    <div className="row">
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="name_pemohon-field" className="form-label">
                          Nama Pemohon
                        </Label>
                        <Input
                          name="nama_pemohon"
                          id="nama_pemohon-field"
                          className="form-control"
                          placeholder="Isi Nama Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nama_pemohon", val);
                          }}
                          value={validation.values.nama_pemohon}
                          invalid={validation.touched.nama_pemohon && validation.errors.nama_pemohon ? true : false}
                        />
                        {validation.touched.nama_pemohon && validation.errors.nama_pemohon ? <FormFeedback type="invalid">{validation.errors.nama_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="alamat_pemohon-field" className="form-label">
                          Alamat Pemohon
                        </Label>
                        <Input
                          name="alamat_pemohon"
                          id="alamat_pemohon-field"
                          className="form-control"
                          placeholder="Isi Alamat Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("alamat_pemohon", val);
                          }}
                          value={validation.values.alamat_pemohon}
                          invalid={validation.touched.alamat_pemohon && validation.errors.alamat_pemohon ? true : false}
                        />
                        {validation.touched.alamat_pemohon && validation.errors.alamat_pemohon ? <FormFeedback type="invalid">{validation.errors.alamat_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="ktp_pemohon-field" className="form-label">
                          KTP Pemohon
                        </Label>
                        <Input
                          name="ktp_pemohon"
                          id="ktp_pemohon-field"
                          className="form-control"
                          placeholder="Isi KTP Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("ktp_pemohon", val);
                          }}
                          value={validation.values.ktp_pemohon}
                          invalid={validation.touched.ktp_pemohon && validation.errors.ktp_pemohon ? true : false}
                        />
                        {validation.touched.ktp_pemohon && validation.errors.ktp_pemohon ? <FormFeedback type="invalid">{validation.errors.ktp_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="pekerjaan_pemohon-field" className="form-label">
                          Pekerjaan Pemohon
                        </Label>
                        <Input
                          name="pekerjaan_pemohon"
                          id="pekerjaan_pemohon-field"
                          className="form-control"
                          placeholder="Isi Pekerjaan Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("pekerjaan_pemohon", val);
                          }}
                          value={validation.values.pekerjaan_pemohon}
                          invalid={validation.touched.pekerjaan_pemohon && validation.errors.pekerjaan_pemohon ? true : false}
                        />
                        {validation.touched.pekerjaan_pemohon && validation.errors.pekerjaan_pemohon ? <FormFeedback type="invalid">{validation.errors.pekerjaan_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="umur_pemohon-field" className="form-label">
                          Umur Pemohon
                        </Label>
                        <Input
                          name="umur_pemohon"
                          id="umur_pemohon-field"
                          className="form-control"
                          placeholder="Isi Umur Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("umur_pemohon", val);
                          }}
                          value={validation.values.umur_pemohon}
                          invalid={validation.touched.umur_pemohon && validation.errors.umur_pemohon ? true : false}
                        />
                        {validation.touched.umur_pemohon && validation.errors.umur_pemohon ? <FormFeedback type="invalid">{validation.errors.umur_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="agama_pemohon-field" className="form-label">
                          Agama Pemohon
                        </Label>
                        <Input
                          name="agama_pemohon"
                          id="agama_pemohon-field"
                          className="form-control"
                          placeholder="Isi Agama Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("agama_pemohon", val);
                          }}
                          value={validation.values.agama_pemohon}
                          invalid={validation.touched.agama_pemohon && validation.errors.agama_pemohon ? true : false}
                        />
                        {validation.touched.agama_pemohon && validation.errors.agama_pemohon ? <FormFeedback type="invalid">{validation.errors.agama_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="telpon_pemohon-field" className="form-label">
                          Telepon Pemohon
                        </Label>
                        <Input
                          name="telpon_pemohon"
                          id="telpon_pemohon-field"
                          className="form-control"
                          placeholder="Isi Telepon Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("telpon_pemohon", val);
                          }}
                          value={validation.values.telpon_pemohon}
                          invalid={validation.touched.telpon_pemohon && validation.errors.telpon_pemohon ? true : false}
                        />
                        {validation.touched.telpon_pemohon && validation.errors.telpon_pemohon ? <FormFeedback type="invalid">{validation.errors.telpon_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="email_pemohon-field" className="form-label">
                          Email Pemohon
                        </Label>
                        <Input
                          name="email_pemohon"
                          id="email_pemohon-field"
                          className="form-control"
                          placeholder="Isi Email Pemohon"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("email_pemohon", val);
                          }}
                          value={validation.values.email_pemohon}
                          invalid={validation.touched.email_pemohon && validation.errors.email_pemohon ? true : false}
                        />
                        {validation.touched.email_pemohon && validation.errors.email_pemohon ? <FormFeedback type="invalid">{validation.errors.email_pemohon}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="nama_kuasa-field" className="form-label">
                          Nama Kuasa
                        </Label>
                        <Input
                          name="nama_kuasa"
                          id="nama_kuasa-field"
                          className="form-control"
                          placeholder="Isi Nama Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nama_kuasa", val);
                          }}
                          value={validation.values.nama_kuasa}
                          invalid={validation.touched.nama_kuasa && validation.errors.nama_kuasa ? true : false}
                        />
                        {validation.touched.nama_kuasa && validation.errors.nama_kuasa ? <FormFeedback type="invalid">{validation.errors.nama_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="alamat_kuasa-field" className="form-label">
                          Alamat Kuasa
                        </Label>
                        <Input
                          name="alamat_kuasa"
                          id="alamat_kuasa-field"
                          className="form-control"
                          placeholder="Isi Alamat Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("alamat_kuasa", val);
                          }}
                          value={validation.values.alamat_kuasa}
                          invalid={validation.touched.alamat_kuasa && validation.errors.alamat_kuasa ? true : false}
                        />
                        {validation.touched.alamat_kuasa && validation.errors.alamat_kuasa ? <FormFeedback type="invalid">{validation.errors.alamat_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="ktp_kuasa-field" className="form-label">
                          KTP Kuasa
                        </Label>
                        <Input
                          name="ktp_kuasa"
                          id="ktp_kuasa-field"
                          className="form-control"
                          placeholder="Isi KTP Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("ktp_kuasa", val);
                          }}
                          value={validation.values.ktp_kuasa}
                          invalid={validation.touched.ktp_kuasa && validation.errors.ktp_kuasa ? true : false}
                        />
                        {validation.touched.ktp_kuasa && validation.errors.ktp_kuasa ? <FormFeedback type="invalid">{validation.errors.ktp_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="pekerjaan_kuasa-field" className="form-label">
                          Pekerjaan Kuasa
                        </Label>
                        <Input
                          name="pekerjaan_kuasa"
                          id="pekerjaan_kuasa-field"
                          className="form-control"
                          placeholder="Isi Pekerjaan Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("pekerjaan_kuasa", val);
                          }}
                          value={validation.values.pekerjaan_kuasa}
                          invalid={validation.touched.pekerjaan_kuasa && validation.errors.pekerjaan_kuasa ? true : false}
                        />
                        {validation.touched.pekerjaan_kuasa && validation.errors.pekerjaan_kuasa ? <FormFeedback type="invalid">{validation.errors.pekerjaan_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="umur_kuasa-field" className="form-label">
                          Umur Kuasa
                        </Label>
                        <Input
                          name="umur_kuasa"
                          id="umur_kuasa-field"
                          className="form-control"
                          placeholder="Isi Umur Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("umur_kuasa", val);
                          }}
                          value={validation.values.umur_kuasa}
                          invalid={validation.touched.umur_kuasa && validation.errors.umur_kuasa ? true : false}
                        />
                        {validation.touched.umur_kuasa && validation.errors.umur_kuasa ? <FormFeedback type="invalid">{validation.errors.umur_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="agama_pemohon-field" className="form-label">
                          Agama Kuasa
                        </Label>
                        <Input
                          name="agama_kuasa"
                          id="agama_kuasa-field"
                          className="form-control"
                          placeholder="Isi Agama Kuasa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("agama_kuasa", val);
                          }}
                          value={validation.values.agama_kuasa}
                          invalid={validation.touched.agama_kuasa && validation.errors.agama_kuasa ? true : false}
                        />
                        {validation.touched.agama_kuasa && validation.errors.agama_kuasa ? <FormFeedback type="invalid">{validation.errors.agama_kuasa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="jalan-field" className="form-label">
                          Jalan/Blok
                        </Label>
                        <Input
                          name="jalan"
                          id="jalan-field"
                          className="form-control"
                          placeholder="Isi Jalan"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("jalan", val);
                          }}
                          value={validation.values.jalan}
                          invalid={validation.touched.jalan && validation.errors.jalan ? true : false}
                        />
                        {validation.touched.jalan && validation.errors.jalan ? <FormFeedback type="invalid">{validation.errors.jalan}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="rt-field" className="form-label">
                          RT
                        </Label>
                        <Input
                          name="rt"
                          id="rt-field"
                          className="form-control"
                          placeholder="Isi RT"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("rt", val);
                          }}
                          value={validation.values.rt}
                          invalid={validation.touched.rt && validation.errors.rt ? true : false}
                        />
                        {validation.touched.rt && validation.errors.rt ? <FormFeedback type="invalid">{validation.errors.rt}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="rw-field" className="form-label">
                          RW
                        </Label>
                        <Input
                          name="rw"
                          id="rw-field"
                          className="form-control"
                          placeholder="Isi RW"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("rw", val);
                          }}
                          value={validation.values.rw}
                          invalid={validation.touched.rw && validation.errors.rw ? true : false}
                        />
                        {validation.touched.rw && validation.errors.rw ? <FormFeedback type="invalid">{validation.errors.rw}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="desa-field" className="form-label">
                          Desa
                        </Label>
                        <Input
                          name="desa"
                          id="desa-field"
                          className="form-control"
                          placeholder="Isi Desa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("desa", val);
                          }}
                          value={validation.values.desa}
                          invalid={validation.touched.desa && validation.errors.desa ? true : false}
                        />
                        {validation.touched.desa && validation.errors.desa ? <FormFeedback type="invalid">{validation.errors.desa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="kecamatan-field" className="form-label">
                          Kecamatan
                        </Label>
                        <Input
                          name="kecamatan"
                          id="kecamatan-field"
                          className="form-control"
                          placeholder="Isi Kecamatan"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("kecamatan", val);
                          }}
                          value={validation.values.kecamatan}
                          invalid={validation.touched.kecamatan && validation.errors.kecamatan ? true : false}
                        />
                        {validation.touched.kecamatan && validation.errors.kecamatan ? <FormFeedback type="invalid">{validation.errors.kecamatan}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="kabupaten-field" className="form-label">
                          Kabupaten
                        </Label>
                        <Input
                          name="kabupaten"
                          id="kabupaten-field"
                          className="form-control"
                          placeholder="Isi Kabupaten"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("kabupaten", val);
                          }}
                          value={validation.values.kabupaten}
                          invalid={validation.touched.kabupaten && validation.errors.kabupaten ? true : false}
                        />
                        {validation.touched.kabupaten && validation.errors.kabupaten ? <FormFeedback type="invalid">{validation.errors.kabupaten}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="propinsi-field" className="form-label">
                          Provinsi
                        </Label>
                        <Input
                          name="propinsi"
                          id="propinsi-field"
                          className="form-control"
                          placeholder="Isi Provinsi"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("propinsi", val);
                          }}
                          value={validation.values.propinsi}
                          invalid={validation.touched.propinsi && validation.errors.propinsi ? true : false}
                        />
                        {validation.touched.propinsi && validation.errors.propinsi ? <FormFeedback type="invalid">{validation.errors.propinsi}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="nib-field" className="form-label">
                          NIB
                        </Label>
                        <Input
                          name="nib"
                          id="nib-field"
                          className="form-control"
                          placeholder="Isi NIB"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nib", val);
                          }}
                          value={validation.values.nib}
                          invalid={validation.touched.nib && validation.errors.nib ? true : false}
                        />
                        {validation.touched.nib && validation.errors.nib ? <FormFeedback type="invalid">{validation.errors.nib}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="status_tanah-field" className="form-label">
                          Status Tanah
                        </Label>
                        <Input
                          name="status_tanah"
                          id="status_tanah-field"
                          className="form-control"
                          placeholder="Isi Status Tanah"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("status_tanah", val);
                          }}
                          value={validation.values.status_tanah}
                          invalid={validation.touched.status_tanah && validation.errors.status_tanah ? true : false}
                        />
                        {validation.touched.status_tanah && validation.errors.status_tanah ? <FormFeedback type="invalid">{validation.errors.status_tanah}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="digunakan_tanah-field" className="form-label">
                          Digunakan Untuk
                        </Label>
                        <Input
                          name="digunakan_tanah"
                          id="digunakan_tanah-field"
                          className="form-control"
                          placeholder="Isi Digunakan Untuk"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("digunakan_tanah", val);
                          }}
                          value={validation.values.digunakan_tanah}
                          invalid={validation.touched.digunakan_tanah && validation.errors.digunakan_tanah ? true : false}
                        />
                        {validation.touched.digunakan_tanah && validation.errors.digunakan_tanah ? <FormFeedback type="invalid">{validation.errors.digunakan_tanah}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="batas_batas_tanah-field" className="form-label">
                          Batas Batas
                        </Label>
                        <Input
                          name="batas_batas_tanah"
                          id="batas_batas_tanah-field"
                          className="form-control"
                          placeholder="Isi Batas Batas"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("batas_batas_tanah", val);
                          }}
                          value={validation.values.batas_batas_tanah}
                          invalid={validation.touched.batas_batas_tanah && validation.errors.batas_batas_tanah ? true : false}
                        />
                        {validation.touched.batas_batas_tanah && validation.errors.batas_batas_tanah ? <FormFeedback type="invalid">{validation.errors.batas_batas_tanah}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="utara-field" className="form-label">
                          Utara
                        </Label>
                        <Input
                          name="utara"
                          id="utara-field"
                          className="form-control"
                          placeholder="Isi Utara"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("utara", val);
                          }}
                          value={validation.values.utara}
                          invalid={validation.touched.utara && validation.errors.utara ? true : false}
                        />
                        {validation.touched.utara && validation.errors.utara ? <FormFeedback type="invalid">{validation.errors.utara}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="timur-field" className="form-label">
                          Timur
                        </Label>
                        <Input
                          name="timur"
                          id="timur-field"
                          className="form-control"
                          placeholder="Isi Timur"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("timur", val);
                          }}
                          value={validation.values.timur}
                          invalid={validation.touched.timur && validation.errors.timur ? true : false}
                        />
                        {validation.touched.timur && validation.errors.timur ? <FormFeedback type="invalid">{validation.errors.timur}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="selatan-field" className="form-label">
                          Selatan
                        </Label>
                        <Input
                          name="selatan"
                          id="selatan-field"
                          className="form-control"
                          placeholder="Isi Selatan"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("selatan", val);
                          }}
                          value={validation.values.selatan}
                          invalid={validation.touched.selatan && validation.errors.selatan ? true : false}
                        />
                        {validation.touched.selatan && validation.errors.selatan ? <FormFeedback type="invalid">{validation.errors.selatan}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="barat-field" className="form-label">
                          Barat
                        </Label>
                        <Input
                          name="barat"
                          id="barat-field"
                          className="form-control"
                          placeholder="Isi Barat"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("barat", val);
                          }}
                          value={validation.values.barat}
                          invalid={validation.touched.barat && validation.errors.barat ? true : false}
                        />
                        {validation.touched.barat && validation.errors.barat ? <FormFeedback type="invalid">{validation.errors.barat}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="tahun_fisik-field" className="form-label">
                          Tahun Fisik
                        </Label>
                        <Input
                          name="tahun_fisik"
                          id="tahun_fisik-field"
                          className="form-control"
                          placeholder="Isi Tahun Fisik"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("tahun_fisik", val);
                          }}
                          value={validation.values.tahun_fisik}
                          invalid={validation.touched.tahun_fisik && validation.errors.tahun_fisik ? true : false}
                        />
                        {validation.touched.tahun_fisik && validation.errors.tahun_fisik ? <FormFeedback type="invalid">{validation.errors.tahun_fisik}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="diperoleh_dari-field" className="form-label">
                          Diproleh Dari
                        </Label>
                        <Input
                          name="diperoleh_dari"
                          id="diperoleh_dari-field"
                          className="form-control"
                          placeholder="Isi Diproleh Dari"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("diperoleh_dari", val);
                          }}
                          value={validation.values.diperoleh_dari}
                          invalid={validation.touched.diperoleh_dari && validation.errors.diperoleh_dari ? true : false}
                        />
                        {validation.touched.diperoleh_dari && validation.errors.diperoleh_dari ? <FormFeedback type="invalid">{validation.errors.diperoleh_dari}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="tahun-field" className="form-label">
                          Tahun
                        </Label>
                        <Input
                          name="tahun"
                          id="tahun-field"
                          className="form-control"
                          placeholder="Isi Tahun"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("tahun", val);
                          }}
                          value={validation.values.tahun}
                          invalid={validation.touched.tahun && validation.errors.tahun ? true : false}
                        />
                        {validation.touched.tahun && validation.errors.tahun ? <FormFeedback type="invalid">{validation.errors.tahun}</FormFeedback> : null}
                      </div>
                      {/* <div className="mb-3 col-lg-4">
                                  <Label htmlFor="batas_batas_tanah-field" className="form-label">
                                    Batasan Tanah
                                  </Label>
                                  <Input
                                    name="batas_batas_tanah"
                                    id="batas_batas_tanah-field"
                                    className="form-control"
                                    placeholder="Isi Batasan Tanah"
                                    type="text"
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      validation.setFieldValue("batas_batas_tanah", val);
                                    }}
                                    value={validation.values.batas_batas_tanah}
                                    invalid={validation.touched.batas_batas_tanah && validation.errors.batas_batas_tanah ? true : false}
                                  />
                                  {validation.touched.batas_batas_tanah && validation.errors.batas_batas_tanah ? <FormFeedback type="invalid">{validation.errors.batas_batas_tanah}</FormFeedback> : null}
                                </div> */}
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="harga_tanah_pasaran-field" className="form-label">
                          Harga Pasaran
                        </Label>
                        <Input
                          name="harga_tanah_pasaran"
                          id="harga_tanah_pasaran-field"
                          className="form-control"
                          placeholder="Isi Harga Pasaran"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("harga_tanah_pasaran", val);
                          }}
                          value={validation.values.harga_tanah_pasaran}
                          invalid={validation.touched.harga_tanah_pasaran && validation.errors.harga_tanah_pasaran ? true : false}
                        />
                        {validation.touched.harga_tanah_pasaran && validation.errors.harga_tanah_pasaran ? <FormFeedback type="invalid">{validation.errors.harga_tanah_pasaran}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="harga_tanah_sppt-field" className="form-label">
                          Harga SPPT
                        </Label>
                        <Input
                          name="harga_tanah_sppt"
                          id="harga_tanah_sppt-field"
                          className="form-control"
                          placeholder="Isi Harga SPPT"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("harga_tanah_sppt", val);
                          }}
                          value={validation.values.harga_tanah_sppt}
                          invalid={validation.touched.harga_tanah_sppt && validation.errors.harga_tanah_sppt ? true : false}
                        />
                        {validation.touched.harga_tanah_sppt && validation.errors.harga_tanah_sppt ? <FormFeedback type="invalid">{validation.errors.harga_tanah_sppt}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="terletak-field" className="form-label">
                          Terletak
                        </Label>
                        <Input
                          name="terletak"
                          id="terletak-field"
                          className="form-control"
                          placeholder="Isi Terletak"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("terletak", val);
                          }}
                          value={validation.values.terletak}
                          invalid={validation.touched.terletak && validation.errors.terletak ? true : false}
                        />
                        {validation.touched.terletak && validation.errors.terletak ? <FormFeedback type="invalid">{validation.errors.terletak}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="nomor-field" className="form-label">
                          Nomor
                        </Label>
                        <Input
                          name="nomor"
                          id="nomor-field"
                          className="form-control"
                          placeholder="Isi Nomor"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nomor", val);
                          }}
                          value={validation.values.nomor}
                          invalid={validation.touched.nomor && validation.errors.nomor ? true : false}
                        />
                        {validation.touched.nomor && validation.errors.nomor ? <FormFeedback type="invalid">{validation.errors.nomor}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="persil-field" className="form-label">
                          Persil
                        </Label>
                        <Input
                          name="persil"
                          id="persil-field"
                          className="form-control"
                          placeholder="Isi Persil"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("persil", val);
                          }}
                          value={validation.values.persil}
                          invalid={validation.touched.persil && validation.errors.persil ? true : false}
                        />
                        {validation.touched.persil && validation.errors.persil ? <FormFeedback type="invalid">{validation.errors.persil}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="kelas-field" className="form-label">
                          Kelas
                        </Label>
                        <Input
                          name="kelas"
                          id="kelas-field"
                          className="form-control"
                          placeholder="Isi Kelas"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("kelas", val);
                          }}
                          value={validation.values.kelas}
                          invalid={validation.touched.kelas && validation.errors.kelas ? true : false}
                        />
                        {validation.touched.kelas && validation.errors.kelas ? <FormFeedback type="invalid">{validation.errors.kelas}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="berdasarkan-field" className="form-label">
                          Berdasarkan
                        </Label>
                        <Input
                          name="berdasarkan"
                          id="berdasarkan-field"
                          className="form-control"
                          placeholder="Isi Berdasarkan"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("berdasarkan", val);
                          }}
                          value={validation.values.berdasarkan}
                          invalid={validation.touched.berdasarkan && validation.errors.berdasarkan ? true : false}
                        />
                        {validation.touched.berdasarkan && validation.errors.berdasarkan ? <FormFeedback type="invalid">{validation.errors.berdasarkan}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label>Tanggal</Label>
                        <div className={"input-group"}>
                          <Flatpickr
                            name="tanggal"
                            className="form-control"
                            placeholder="Tanggal"
                            value={validation.values.tanggal ?? ""}
                            onChange={(obj, str) => {
                              validation.setFieldValue("tanggal", str);
                            }}
                          />
                          {validation.touched.tanggal && validation.errors.tanggal ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.tanggal}
                            </small>
                          ) : null}
                          <span className="input-group-text">
                            <i className="ri-calendar-event-line"></i>
                          </span>
                        </div>
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="kepala_desa-field" className="form-label">
                          Kepala Desa
                        </Label>
                        <Input
                          name="kepala_desa"
                          id="kepala_desa-field"
                          className="form-control"
                          placeholder="Isi Kepala Desa"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("kepala_desa", val);
                          }}
                          value={validation.values.kepala_desa}
                          invalid={validation.touched.kepala_desa && validation.errors.kepala_desa ? true : false}
                        />
                        {validation.touched.kepala_desa && validation.errors.kepala_desa ? <FormFeedback type="invalid">{validation.errors.kepala_desa}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="nama_saksi1-field" className="form-label">
                          Nama Saksi
                        </Label>
                        <Input
                          name="nama_saksi1"
                          id="nama_saksi1-field"
                          className="form-control"
                          placeholder="Isi Nama Saksi"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nama_saksi1", val);
                          }}
                          value={validation.values.nama_saksi1}
                          invalid={validation.touched.nama_saksi1 && validation.errors.nama_saksi1 ? true : false}
                        />
                        {validation.touched.nama_saksi1 && validation.errors.nama_saksi1 ? <FormFeedback type="invalid">{validation.errors.nama_saksi1}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="umur_saksi1-field" className="form-label">
                          Umur Saksi
                        </Label>
                        <Input
                          name="umur_saksi1"
                          id="umur_saksi1-field"
                          className="form-control"
                          placeholder="Isi Umur Saksi"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("umur_saksi1", val);
                          }}
                          value={validation.values.umur_saksi1}
                          invalid={validation.touched.umur_saksi1 && validation.errors.umur_saksi1 ? true : false}
                        />
                        {validation.touched.umur_saksi1 && validation.errors.umur_saksi1 ? <FormFeedback type="invalid">{validation.errors.umur_saksi1}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="pekerjaan_saksi1-field" className="form-label">
                          Pekerjaan Saksi
                        </Label>
                        <Input
                          name="pekerjaan_saksi1"
                          id="pekerjaan_saksi1-field"
                          className="form-control"
                          placeholder="Isi Pekerjaan Saksi"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("pekerjaan_saksi1", val);
                          }}
                          value={validation.values.pekerjaan_saksi1}
                          invalid={validation.touched.pekerjaan_saksi1 && validation.errors.pekerjaan_saksi1 ? true : false}
                        />
                        {validation.touched.pekerjaan_saksi1 && validation.errors.pekerjaan_saksi1 ? <FormFeedback type="invalid">{validation.errors.pekerjaan_saksi1}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="alamat_saksi1-field" className="form-label">
                          Alamat Saksi
                        </Label>
                        <Input
                          name="alamat_saksi1"
                          id="alamat_saksi1-field"
                          className="form-control"
                          placeholder="Isi Alamat Saksi"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("alamat_saksi1", val);
                          }}
                          value={validation.values.alamat_saksi1}
                          invalid={validation.touched.alamat_saksi1 && validation.errors.alamat_saksi1 ? true : false}
                        />
                        {validation.touched.alamat_saksi1 && validation.errors.alamat_saksi1 ? <FormFeedback type="invalid">{validation.errors.alamat_saksi1}</FormFeedback> : null}
                      </div>

                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="nama_saksi2-field" className="form-label">
                          Nama Saksi 2
                        </Label>
                        <Input
                          name="nama_saksi2"
                          id="nama_saksi2-field"
                          className="form-control"
                          placeholder="Isi Nama Saksi 2"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("nama_saksi2", val);
                          }}
                          value={validation.values.nama_saksi2}
                          invalid={validation.touched.nama_saksi2 && validation.errors.nama_saksi2 ? true : false}
                        />
                        {validation.touched.nama_saksi2 && validation.errors.nama_saksi2 ? <FormFeedback type="invalid">{validation.errors.nama_saksi2}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="umur_saksi2-field" className="form-label">
                          Umur Saksi 2
                        </Label>
                        <Input
                          name="umur_saksi2"
                          id="umur_saksi2-field"
                          className="form-control"
                          placeholder="Isi Umur Saksi 2"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("umur_saksi2", val);
                          }}
                          value={validation.values.umur_saksi2}
                          invalid={validation.touched.umur_saksi2 && validation.errors.umur_saksi2 ? true : false}
                        />
                        {validation.touched.umur_saksi2 && validation.errors.umur_saksi2 ? <FormFeedback type="invalid">{validation.errors.umur_saksi2}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="pekerjaan_saksi2-field" className="form-label">
                          Pekerjaan Saksi 2
                        </Label>
                        <Input
                          name="pekerjaan_saksi2"
                          id="pekerjaan_saksi2-field"
                          className="form-control"
                          placeholder="Isi Pekerjaan Saksi 2"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("pekerjaan_saksi2", val);
                          }}
                          value={validation.values.pekerjaan_saksi2}
                          invalid={validation.touched.pekerjaan_saksi2 && validation.errors.pekerjaan_saksi2 ? true : false}
                        />
                        {validation.touched.pekerjaan_saksi2 && validation.errors.pekerjaan_saksi2 ? <FormFeedback type="invalid">{validation.errors.pekerjaan_saksi2}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="alamat_saksi2-field" className="form-label">
                          Alamat Saksi 2
                        </Label>
                        <Input
                          name="alamat_saksi2"
                          id="alamat_saksi2-field"
                          className="form-control"
                          placeholder="Isi Alamat Saksi 2"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("alamat_saksi2", val);
                          }}
                          value={validation.values.alamat_saksi2}
                          invalid={validation.touched.alamat_saksi2 && validation.errors.alamat_saksi2 ? true : false}
                        />
                        {validation.touched.alamat_saksi2 && validation.errors.alamat_saksi2 ? <FormFeedback type="invalid">{validation.errors.alamat_saksi2}</FormFeedback> : null}
                      </div>
                      <div className="mb-3 col-lg-4">
                        <Label htmlFor="jenis_permohonan-field" className="form-label">
                          Jenis Permohonan
                        </Label>
                        <Input
                          name="jenis_permohonan"
                          id="jenis_permohonan-field"
                          className="form-control"
                          placeholder="Isi Jenis Permohonan"
                          type="text"
                          onChange={(e) => {
                            const val = e.target.value;
                            validation.setFieldValue("jenis_permohonan", val);
                          }}
                          value={validation.values.jenis_permohonan}
                          invalid={validation.touched.jenis_permohonan && validation.errors.jenis_permohonan ? true : false}
                        />
                        {validation.touched.jenis_permohonan && validation.errors.jenis_permohonan ? <FormFeedback type="invalid">{validation.errors.jenis_permohonan}</FormFeedback> : null}
                      </div>

                      <div className="mb-3 col-lg-4">
                        <Label>Tanggal SPS Terbit</Label>
                        <div className={"input-group"}>
                          <Flatpickr
                            name="sps_tgl_terbit"
                            className="form-control"
                            placeholder="Tanggal"
                            value={validation.values.sps_tgl_terbit ?? ""}
                            onChange={(obj, str) => {
                              validation.setFieldValue("sps_tgl_terbit", str);
                            }}
                          />
                          {validation.touched.sps_tgl_terbit && validation.errors.sps_tgl_terbit ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.sps_tgl_terbit}
                            </small>
                          ) : null}
                          <span className="input-group-text">
                            <i className="ri-calendar-event-line"></i>
                          </span>
                        </div>
                      </div>

                      <div className="mb-3 col-lg-4">
                        <Label>Tanggal SPS Maksimal</Label>
                        <div className={"input-group"}>
                          <Flatpickr
                            name="sps_tgl_maksimal"
                            className="form-control"
                            placeholder="Tanggal"
                            value={validation.values.sps_tgl_maksimal ?? ""}
                            onChange={(obj, str) => {
                              validation.setFieldValue("sps_tgl_maksimal", str);
                            }}
                          />
                          {validation.touched.sps_tgl_maksimal && validation.errors.sps_tgl_maksimal ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.sps_tgl_maksimal}
                            </small>
                          ) : null}
                          <span className="input-group-text">
                            <i className="ri-calendar-event-line"></i>
                          </span>
                        </div>
                      </div>

                      <div className="mb-3 col-lg-4">
                        <Label>Tanggal Pengukuran</Label>
                        <div className={"input-group"}>
                          <Flatpickr
                            name="tgl_pengukuran"
                            className="form-control"
                            placeholder="Tanggal"
                            value={validation.values.tgl_pengukuran ?? ""}
                            onChange={(obj, str) => {
                              validation.setFieldValue("tgl_pengukuran", str);
                            }}
                          />
                          {validation.touched.tgl_pengukuran && validation.errors.tgl_pengukuran ? (
                            <small className="text-danger" type="invalid">
                              {validation.errors.tgl_pengukuran}
                            </small>
                          ) : null}
                          <span className="input-group-text">
                            <i className="ri-calendar-event-line"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <h5 className="mb-3 mt-3 bg-soft-info p-2 pb-3">SK Penetapan</h5>
                    <div className="row"></div>

                    <h5 className="mb-3 mt-3 bg-soft-info p-2 pb-3">Cetak Sertifikat</h5>
                    <div className="row"></div>
                  </Col>
                </Row>
              </CardBody>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModal(false);
                    validation.resetForm({});
                  }}
                >
                  TUTUP
                </button>

                <button type="submit" className="btn btn-success" disabled={loading}>
                  <span className="d-flex align-items-center">
                    SIMPAN
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    value={validationAccPayable.values.amount}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && (
                    <p className="invalid-feedback d-block" type="invalid">
                      {validationAccPayable.errors.amount}
                    </p>
                  )}
                </div>
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""}
                  />
                </div>
                <div className="mb-3 col-lg-4">
                  <Label className="form-label">Cashflow</Label>
                  <Select
                    name="cashflow"
                    value={validationAccPayable.values.cashflow}
                    placeholder="Pilih Cashflow"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("cashflow", e);
                    }}
                    options={budgetList}
                  ></Select>
                  {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.cashflow}
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <Label htmlFor="address-field" className="form-label">
                    Keterangan
                  </Label>
                  <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                  {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.description}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}
                >
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            {`View ${detailType}`}
          </ModalHeader>
          {info !== undefined && info !== null && (
            <>
              <PrintDocF4 innerRef={printRef} item={info} type={detailType} />
            </>
          )}

          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}
              >
                TUTUP
              </button>
              {<ButtonPrintF4 innerRef={printRef} title={`${detailType}-${info?.nama ?? ""}`} />}
            </div>
          </div>
        </Modal>

        {/* /// */}
        <Modal id="showModal" isOpen={modalTrans} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleTrans}>
            {info?.material_name ?? ""}
          </ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold  text-start">
                        <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchListTrans(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportDoc data={printTransDoc} />
                  </div>
                </Row>
                <SimpleBar style={{ height: "450px" }}>
                  <Table className="table-border text-center table-hover">
                    <thead className="align-middle">
                      <tr className="table-active">
                        <td style={{ width: "20px" }}>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={expense.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = expense.every((item) => item.isChecked);
                              const updatedData = expense.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setExpense(updatedData);
                            }}
                          />
                        </td>
                        <td className="text-center" style={{ width: "100px" }}>
                          No Transaksi
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Tanggal
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Jenis
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Tag
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Jumlah
                        </td>
                        <td className="text-center" style={{ width: "200px" }}>
                          Keterangan
                        </td>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {(expense || []).map((o, i) => {
                        let type;
                        switch (o.type) {
                          case "CASH IN":
                            type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                            break;
                          case "RECEIVABLE":
                            type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                            break;
                          case "CASH OUT":
                            type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                            break;
                          case "PAYABLE":
                            type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                            break;
                          default:
                            type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                            break;
                        }
                        return (
                          // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                          <tr key={i}>
                            <td style={{ verticalAlign: "middle", width: "30px" }}>
                              <div className="hstack gap-2 mt-4 mt-sm-0">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />
                              </div>
                            </td>
                            {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {o.transaction_no}
                              {o.statusId === 4 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                </p>
                              )}
                              {o.statusId === 3 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                </p>
                              )}
                              {o.statusId === 2 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                </p>
                              )}
                              {o.statusId === 1 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                </p>
                              )}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {handleValidDate(o.transactionat)}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {type}
                            </td>
                            <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                              {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {currencyFormat(o.amount)}
                            </td>
                            <td className="text-left" style={{ verticalAlign: "middle" }}>
                              {o.description}
                            </td>
                          </tr>
                        );
                      })}

                      {expense.length === 0 && (
                        <tr>
                          <td colSpan="7" className="p-3 text-center">
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
                <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                  <div className="col-sm-6 fs-12 text-start">
                    HUTANG:
                    <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                      {currencyFormat(
                        (expense || [])
                          .filter((el) => el.type === "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                          .map((el) => parseFloat(el.amount || 0))
                          .reduce((prev, curr) => prev + curr, 0)
                      )}
                    </span>
                  </div>
                  <div className="col-sm-6 fs-12 text-end">
                    PEMBAYARAN KAS / BANK :
                    <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                      {currencyFormat(
                        (expense || [])
                          .filter((el) => el.type !== "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                          .map((el) => parseFloat(el.amount || 0))
                          .reduce((prev, curr) => prev + curr, 0)
                      )}
                    </span>
                  </div>
                </Row>
              </div>
            </CardBody>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default withRouter(withTranslation()(LegalMaster));
